var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.loading
    ? _c(
        "div",
        [
          _c(
            "div",
            { staticClass: "header-actions" },
            [
              _c("CorpId"),
              _vm._v(" "),
              _c("CompassButton", {
                staticClass: "ml-3",
                attrs: {
                  label: _vm.$t.__("developerPage.Widgets.add_widget"),
                  type: "primary"
                },
                on: { click: _vm.createWidget }
              })
            ],
            1
          ),
          _vm._v(" "),
          _vm.widgets.length
            ? _c(
                "el-table",
                {
                  attrs: {
                    data: _vm.widgets,
                    "default-sort": { prop: "name", order: "ascending" },
                    border: ""
                  }
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "name",
                      label: _vm.$t.__("common.labels.name"),
                      width: "200",
                      sortable: "",
                      "show-overflow-tooltip": ""
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: _vm.$t.__("common.labels.address") },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "a",
                                {
                                  staticClass: "primary-50",
                                  attrs: {
                                    href: scope.row.website,
                                    target: "_blank"
                                  }
                                },
                                [_vm._v(_vm._s(scope.row.website))]
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      821042952
                    )
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t.__("developerPage.Widgets.code_to_insert")
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c("el-input", {
                                attrs: {
                                  type: "textarea",
                                  rows: 4,
                                  readonly: true
                                },
                                model: {
                                  value: scope.row.formatted_hash,
                                  callback: function($$v) {
                                    _vm.$set(scope.row, "formatted_hash", $$v)
                                  },
                                  expression: "scope.row.formatted_hash"
                                }
                              })
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      4070006999
                    )
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      fixed: "right",
                      label: _vm.$t.__("common.labels.actions"),
                      width: "250"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "div",
                                { staticClass: "flex-row" },
                                [
                                  _c("CompassButton", {
                                    attrs: {
                                      label: _vm.$t.__("common.actions.edit"),
                                      type: "primary-contrast"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.editWidget(scope.row.id)
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("CompassButton", {
                                    staticClass: "ml-2",
                                    attrs: {
                                      label: _vm.$t.__("common.actions.delete"),
                                      type: "tertiary-destructive"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.deleteWidget(scope.row.id)
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      1461384575
                    )
                  })
                ],
                1
              )
            : _c("div", { staticClass: "placeholder well" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.$l10n.__("Vous ne disposez d'aucun formulaire actif")
                    ) +
                    "\n    "
                )
              ])
        ],
        1
      )
    : _c("preloader", { attrs: { background: false, display: true } })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }